import { render, staticRenderFns } from "./gRNAResult.vue?vue&type=template&id=4580ec8b&scoped=true"
import script from "./gRNAResult.vue?vue&type=script&lang=js"
export * from "./gRNAResult.vue?vue&type=script&lang=js"
import style0 from "./gRNAResult.vue?vue&type=style&index=0&id=4580ec8b&prod&lang=less&scoped=true"
import style1 from "./gRNAResult.vue?vue&type=style&index=1&id=4580ec8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580ec8b",
  null
  
)

export default component.exports